import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Observable } from "rxjs/Observable";
import { ConstantsStore } from "@store/constants";
import { WorkshopsStore } from "@store/workshops";
import { Term } from "@models/term";
import { Workshop } from "@models/workshop";
import { Campus } from "@models/campus";
import { Window } from "@models/window";
import { WorkshopCampusFormComponent } from "./workshop-campus-form";
import { ModalService, ModalConfig } from "@services/modal";
import {
  CompleterData,
  CompleterService,
  CompleterItem } from "ng2-completer";
import {
  FETCH_WORKSHOPS,
  POPULATE_ACTIVE_WORKSHOP,
  POPULATE_ACTIVE_CAMPUS
} from "@reducers/workshops";

@Component({
  selector: 'workshops-timetable-view',
  templateUrl: './workshops-timetable-view.pug',
})
export class WorkshopsTimetableViewComponent implements OnInit {

  public terms: Term[]
  public activeTerm: Term
  public workshops: Workshop[]

  public constantsStore: Observable<ConstantsStore>
  public workshopsStore: Observable<WorkshopsStore>

  public termSearchStr: string
  public termCompleter: CompleterData

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.constantsStore = this.store.select("constantsReducer")
    this.workshopsStore = this.store.select("workshopsReducer")

    this.constantsStore.subscribe((s: ConstantsStore) => {
      this.terms          = s.constants.terms.filter(t => !t.isHoliday)
      this.termCompleter  = 
        this.completerService.local(this.terms, "name", "name")
    })

    this.workshopsStore.subscribe((s: WorkshopsStore) => {
      this.workshops = s.workshops
    })

    this.activeTerm = this.terms[0]
  }

  clickedEditWorkshopCampus(workshop: Workshop, campus: Campus) {
    this.store.dispatch({ type: POPULATE_ACTIVE_WORKSHOP, payload: workshop })
    this.store.dispatch({ type: POPULATE_ACTIVE_CAMPUS, payload: campus })
    this.modalService.showModal(new ModalConfig(WorkshopCampusFormComponent))
  }

  selectedTerm(e: CompleterItem) {
    if (e) { this.activeTerm = e.originalObject as Term }
  }

  populateWorkshops(termId: number) {
    this.store.dispatch({ type: FETCH_WORKSHOPS, payload: termId })
  }

  windowsForCampus(workshop: Workshop, campus: Campus): Window[] {
    return workshop.windows.filter((w: Window) => {
      return w.campusId === campus.id
    })
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/workshops-timetable-view.ts